/** @format */
import React, { useEffect, useState } from 'react';
import GridItem from '../../../components/Grid/GridItem';
import GridContainer from '../../../components/Grid/GridContainer';
import InputFormRest from '../../../components/Form/InputFormRest';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import CheckBoxSimple from '../../../components/Form/CheckBoxSimple';
import { Moment } from 'moment';
import { DiscountRateEntity } from '../PlatformResellerDiscount/PlatformResellerRateDiscount';
import { SimpleSelect } from '../../../components/Adescom/SimpleSelect';
import { DiscountHelper } from '../../../helpers/DiscountHelper';
import i18n from 'i18next';
import { Fraction } from '../../../interfaces/platform/Fraction';
import PrefixInterface from '../../../interfaces/billing/PrefixInterface';
import FractionSelection from './FractionSelection';
import PrefixSelection from './PrefixSelection';
import { RateCall } from '../../Pricelists/Components/PricelistSchemaElementDialog/RateCall';
import { RateService } from '../../Pricelists/Components/PricelistSchemaElementDialog/RateService';
import RateSchemaInterface from '../../../interfaces/billing/RateSchemaInterface';
import Card from '../../../components/Card/Card';
import CustomDatePicker from '../../../components/Form/CustomDatePicker';
import { DiscountInterface } from '../../../interfaces/billing/DiscountInterface';
import { PriceThresholdContainer, PriceThresholdEntityInterface } from '../../Pricelists/Components/PriceThresholds/PriceThresholdContainer';
import { useDispatch } from 'react-redux';

interface DiscountFormProps {
    entity: DiscountRateEntity;
    setEntity: (entity: DiscountRateEntity) => void;
    entityStatus: any;
    setEntityStatus: (entityStatus: any) => void;
    rateEntity: RateSchemaInterface;
    setRateEntity: (rate: RateSchemaInterface) => void;
    rateEntityStatus: any;
    changeRateInput: (e: any, stateName: string) => void;
    changeRateSelect: (e: any, stateName: string) => void;
    activeDiscount: DiscountInterface | null;
    isOpen: boolean;
    setPriceThresholds: (thresholds: Array<PriceThresholdEntityInterface>) => void;
    priceThresholds: Array<PriceThresholdEntityInterface>;
    afterInitLoad: boolean;
    setAfterInitLoad: (afterInitLoad: boolean) => void;
}

const DiscountRateForm = (props: DiscountFormProps): React.ReactElement => {
    const { entity, setEntity, entityStatus, setEntityStatus, afterInitLoad, setAfterInitLoad } = props;

    const [rateType, setRateType] = useState<number>(4);

    const dispatch = useDispatch();

    const updateCallback = (
        event: React.FormEvent<HTMLInputElement>,
        stateName: string,
        typeField: string,
        typeCallback: string,
        required: boolean,
        vMax: number,
        vMin?: number
    ): void => {
        const tmp = { ...entity };
        FormGeneralHelper.validateFormsHook(tmp, setEntity, entityStatus, setEntityStatus, event, stateName, typeField, require, vMax, vMin);
    };
    const selectCallback = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        if (e.target.name === 'type') {
            setRateType(parseInt(e.target.value));
        }
        setEntity({ ...entity, [e.target.name]: e.target.value });
    };

    const getSelectedFractions = (fractions: Array<Fraction>): void => {
        let ids = fractions.map((el: Fraction) => el.id);
        const idsAsStr = ids.join(',');
        setEntity({ ...entity, destination: idsAsStr });
    };
    const getSelectedPrefixes = (prefixes: Array<PrefixInterface>): void => {
        let pref = prefixes.map((el: PrefixInterface) => el.prefix);
        const prefAsStr = pref.join(',');
        setEntity({ ...entity, destination: prefAsStr });
    };

    useEffect(() => {
        if (props.rateEntity.type === 3 && entity.type !== DiscountHelper.COST_TYPE.SERVICE && !afterInitLoad) {
            setRateType(DiscountHelper.COST_TYPE.SERVICE);
            setEntity({ ...entity, type: DiscountHelper.COST_TYPE.SERVICE });
            setAfterInitLoad(true);
        }
    }, [props.rateEntity, setEntity, entity, afterInitLoad, setAfterInitLoad]);

    useEffect(() => {
        if (!props.activeDiscount) {
            setRateType(4);
        }
    }, [props.activeDiscount]);

    // useEffect(() => {
    //     console.log(props.entity);
    // }, [props.entity]);

    return (
        <GridContainer>
            <GridContainer spacing={1}>
                <GridItem xs={5}>
                    <InputFormRest
                        stateName={'name'}
                        displayFieldName={'discount:h.name'}
                        value={entity.name}
                        stateObjectState={entityStatus.name}
                        typeCallback={FormGeneralHelper.TYPE_TEXT}
                        typeField={FormGeneralHelper.TYPE_TEXT}
                        callback={updateCallback}
                        required={true}
                        vMin={1}
                        vMax={255}
                    />
                </GridItem>
                <GridItem xs={3}>
                    <InputFormRest
                        stateName={'priority'}
                        displayFieldName={'discount:h.priority'}
                        value={entity.priority}
                        stateObjectState={entityStatus.priority}
                        typeCallback={FormGeneralHelper.TYPE_NUMBER}
                        typeField={FormGeneralHelper.TYPE_NUMBER}
                        callback={updateCallback}
                        required={true}
                        vMin={1}
                        vMax={255}
                    />
                </GridItem>
                <GridItem xs={4}>
                    <CheckBoxSimple
                        checked={entity.useAllResellerNumbers}
                        disabled={entity.allowUseOnProduct > 0}
                        label={'discount:h.include_operator_contracts'}
                        callback={(param: boolean): void => setEntity({ ...entity, useAllResellerNumbers: param })}
                    />
                </GridItem>
                <GridItem xs={3}>
                    <CheckBoxSimple
                        checked={entity.active}
                        label={'discount:h.active'}
                        callback={(param: boolean): void => setEntity({ ...entity, active: param })}
                    />
                </GridItem>
                <GridItem xs={3}>
                    <CheckBoxSimple
                        checked={entity.allowUseOnProduct > 0}
                        disabled={entity.useAllResellerNumbers}
                        label={'discount:h.allow_use_on_product'}
                        callback={(param: boolean): void => setEntity({ ...entity, allowUseOnProduct: param ? 1 : -1 })}
                    />
                </GridItem>
                <GridItem xs={3}>
                    <CheckBoxSimple
                        checked={entity.propOnFirstMonth === true}
                        label={'discount:h.prop_on_first_month'}
                        callback={(param: boolean): void => setEntity({ ...entity, propOnFirstMonth: param })}
                    />
                </GridItem>
                <GridItem xs={3}>
                    <CheckBoxSimple
                        checked={props.rateEntity.useRatio}
                        label={'pricelists:h.count_proportionally'}
                        callback={(param: boolean): void => props.setRateEntity({ ...props.rateEntity, useRatio: param })}
                    />
                </GridItem>

                <GridItem xs={3} />
                {entity.allowUseOnProduct === 1 && (
                    <GridContainer spacing={1}>
                        <GridItem xs={12}>
                            <GridContainer>
                                <GridItem xs={3} />
                                <GridItem xs={3}>
                                    <InputFormRest
                                        stateName={'customPrefix'}
                                        displayFieldName={'discount:h.custom_prefix'}
                                        value={entity.customPrefix}
                                        stateObjectState={entityStatus.customPrefix}
                                        typeCallback={FormGeneralHelper.TYPE_TEXT}
                                        typeField={FormGeneralHelper.TYPE_TEXT}
                                        callback={updateCallback}
                                        required={false}
                                        vMin={1}
                                        vMax={255}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                )}
                <GridItem xs={6}>
                    <CustomDatePicker
                        helpText={'discount:h.date_start'}
                        fieldName={'dateStart'}
                        callback={(moment: Moment | string): void => setEntity({ ...entity, dateStart: moment })}
                        dateFormat={'DD-MM-YYYY'}
                        autoComplete={'off'}
                        defaultValue={entity.dateStart}
                    />
                </GridItem>
                <GridItem xs={6}>
                    <CustomDatePicker
                        helpText={'discount:h.date_end'}
                        fieldName={'dateEnd'}
                        callback={(moment: Moment | string): void => setEntity({ ...entity, dateEnd: moment })}
                        dateFormat={'DD-MM-YYYY'}
                        placeholder={'DD-MM-YYYY'}
                        autoComplete={'off'}
                        defaultValue={entity.dateEnd}
                    />
                </GridItem>
                <GridItem xs={12}>
                    <CheckBoxSimple
                        checked={entity.autoShare}
                        label={'discount:h.auto_share'}
                        callback={(param: boolean): void => setEntity({ ...entity, autoShare: param })}
                    />
                </GridItem>
            </GridContainer>
            <GridContainer spacing={1}>
                <GridItem xs={6}>
                    <SimpleSelect
                        label={'discount:h.layout'}
                        required={true}
                        elements={DiscountHelper.getLayout()}
                        dispatchName={'layout'}
                        fieldName={'layout'}
                        selectedValue={entity.layout}
                        callback={selectCallback}
                    />
                </GridItem>
                <GridItem xs={6}>
                    <SimpleSelect
                        label={'discount:h.currency'}
                        required={true}
                        elements={[{ name: i18n.t('discount:s.default_currency'), value: 0 }]}
                        dispatchName={'currency'}
                        selectedValue={entity.currency}
                    />
                </GridItem>
                <GridItem xs={3}>
                    <SimpleSelect
                        label={'discount:h.type'}
                        required={true}
                        elements={DiscountHelper.getType()}
                        dispatchName={'type'}
                        selectedValue={entity.type}
                        fieldName={'type'}
                        callback={selectCallback}
                    />
                </GridItem>
                <GridItem xs={9}>
                    <GridContainer>
                        <GridItem xs={12}>
                            {rateType === 4 && (
                                <RateCall
                                    changeRateInput={props.changeRateInput}
                                    changeRateSelect={props.changeRateSelect}
                                    rateEntity={props.rateEntity}
                                    rateEntityStatus={props.rateEntityStatus}
                                />
                            )}
                            {rateType === 5 && (
                                <RateService
                                    changeRateInput={props.changeRateInput}
                                    rateEntity={props.rateEntity}
                                    rateEntityStatus={props.rateEntityStatus}
                                />
                            )}
                        </GridItem>
                    </GridContainer>
                </GridItem>
            </GridContainer>

            <GridContainer>
                <GridItem xs={12}>
                    <PriceThresholdContainer
                        isOpen={props.isOpen}
                        priceThresholds={props.priceThresholds}
                        setPriceThresholds={props.setPriceThresholds}
                        rateEntity={props.rateEntity}
                        parentComponent={'discount'}
                    />
                </GridItem>
            </GridContainer>
            <GridContainer>
                <GridItem xs={6}>
                    <SimpleSelect
                        label={'discount:h.filter_type'}
                        fieldName={'filterType'}
                        required={true}
                        elements={DiscountHelper.getRateDestinationType()}
                        dispatchName={'filterType'}
                        selectedValue={entity.filterType}
                        callback={selectCallback}
                    />
                </GridItem>
                <GridItem xs={12}>
                    {entity.filterType === DiscountHelper.DESTINATION.DESTINATION_FRACTIONS && (
                        <FractionSelection getSelectedFractions={getSelectedFractions} entity={entity} />
                    )}
                    {entity.filterType === DiscountHelper.DESTINATION.DESTINATION_PREFIXES && (
                        <PrefixSelection getSelectedPrefixes={getSelectedPrefixes} entity={entity} />
                    )}
                </GridItem>
            </GridContainer>
        </GridContainer>
    );
};

export default DiscountRateForm;
